import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "@/components/ui/card";

const steps = [
  {
    title: "Define Task",
    description: "Specify the penetration testing task you want to perform.",
  },
  {
    title: "AI Analysis",
    description: "PentAGI analyzes the task and determines the best approach.",
  },
  {
    title: "Automated Testing",
    description: "The AI agent performs the penetration testing autonomously.",
  },
  {
    title: "Real-time Monitoring",
    description:
      "Watch the testing process unfold in real-time through the modern UI.",
  },
  {
    title: "Results & Reporting",
    description: "Receive comprehensive results and actionable insights.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-20">
      <div className="container mx-auto">
        <h2 className="text-3xl font-bold mb-12 text-center">How It Works</h2>
        <div className="space-y-6">
          {steps.map((step, index) => (
            <Card key={index}>
              <CardHeader>
                <CardTitle className="flex items-center">
                  <span className="w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center mr-3">
                    {index + 1}
                  </span>
                  {step.title}
                </CardTitle>
                <CardDescription>{step.description}</CardDescription>
              </CardHeader>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
